// Тон блока инструкции ("cyan"/"red"/"teal"/"violet"...) задаётся в конфиге панели
// (поле config.platforms[].apps[].blocks[].svgIconColor — несмотря на название, это тег тона,
// а не hex-цвет), но сам цвет — из палитры темы, а не из панели напрямую. Портировано из
// sub-page/src/views/helpers.ts (installToneBorderClass/installToneTextClass).
const TONE_BORDER: Record<string, string> = {
  cyan: "border-accent-blue",
  red: "border-accent-red",
  teal: "border-accent-green",
  violet: "border-accent-yellow",
};

const TONE_TEXT: Record<string, string> = {
  cyan: "text-accent-blue",
  red: "text-accent-red",
  teal: "text-accent-green",
  violet: "text-accent-yellow",
};

export function installToneBorderClass(tone?: string): string {
  return TONE_BORDER[tone ?? ""] ?? "border-accent-blue";
}

export function installToneTextClass(tone?: string): string {
  return TONE_TEXT[tone ?? ""] ?? "text-accent-blue";
}
